/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 11:47:21 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Filter, TextInput } from 'react-admin';

const OrganisationFilter = props => {
  return (
    <Filter {...props}>
      <TextInput
        label="resources.Organisation.fields.organisation"
        source="name"
        alwaysOn
      />
    </Filter>
  );
};

export default OrganisationFilter;
